import { Link, Route, Routes } from 'react-router-dom';

import './App.css';
import Logo from './components/Logo';
import DefaultPage from './pages/DefaultPage';
import ServicePage from './pages/ServicePage';

function App() {

  const services = ["anamnesis", "appointment", "consent", "documentation-template", "doc-cirrus-gw", "patient", "practice", "medical-catalog", "health-plan", "zammad-adapter", "patient-messaging"];
  services.sort();
  const gateways = ["patient-mobile-api", "patient-web-api", "practice-app-api", "partner-api", "event-stream"];
  gateways.sort();
 
  return (
    <div className="App">
      <div className="sidebar">
        <div className="header">
          <Link to={"/"}><Logo /></Link>
          API Documentation
        </div>

        <p style={{color:'#226a6d'}}><b>API Gateways</b></p>
        <nav>
          {gateways.map(gateway => (
            <Link className="menu-link" to={`/${gateway}`}>{gateway}</Link>
          ))}
        </nav>

        <br/>
        <p style={{color:'#226a6d'}}><b>Services</b></p>
        <nav>
          {services.map(service => (
            <Link className="menu-link" to={`/${service}`}>{service}</Link>
          ))}
        </nav>
      </div>
      <div className="main-content">
        <Routes>
          <Route path="/" element={<DefaultPage />} />
          {gateways.concat(services).map(service => (
              <Route path={`/${service}`} element={<ServicePage service={service} />} />
          ))}
        </Routes>
      </div>
    </div>
  );
}

export default App;
